import { ref, onMounted, reactive } from "vue";
export default {
  name: "Culture",
  setup: function setup() {
    return {};
  }
};